"use client"

import Link from "next/link"
import { useState } from "react"

import { MobileNav } from "./components/MobileNav"

const NAV = [
  { href: "/templates", label: "Templates" },
  { href: "/how-it-works", label: "How it works" },
  { href: "/faq", label: "FAQ" },
  {
    href: "https://github.com/adkotlorz/lyric-vizr",
    label: "GitHub",
    external: true,
  },
] as const

export function Header() {
  const [open, setOpen] = useState(false)
  return (
    <header className="relative flex items-center justify-between gap-6 px-4 sm:px-6 md:px-8 py-4 md:py-5 border-b border-fg/10 bg-surface text-fg">
      <Link
        href="/"
        className="text-xl tracking-[0.15em] font-[var(--font-display)] hover:opacity-80 transition-opacity"
      >
        VerseMotion
      </Link>
      <nav className="hidden md:block">
        <ul className="flex items-center gap-6 text-sm">
          {NAV.map((item) =>
            "external" in item && item.external ? (
              <li key={item.href}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-fg/70 hover:text-fg transition-colors"
                >
                  {item.label}
                </a>
              </li>
            ) : (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className="text-fg/70 hover:text-fg transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ),
          )}
        </ul>
      </nav>
      <button
        type="button"
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        aria-controls="mobile-nav-panel"
        onClick={() => setOpen((v) => !v)}
        className="md:hidden inline-flex items-center justify-center w-11 h-11 -mr-2 text-fg/80 hover:text-fg"
      >
        <span
          aria-hidden="true"
          className="text-xl"
        >
          {open ? "×" : "☰"}
        </span>
      </button>
      <MobileNav
        open={open}
        items={NAV}
        onClose={() => setOpen(false)}
      />
    </header>
  )
}
